<template>
	<select @change='change' :id="id" v-model="selected" class='form-control table-control my-control' data-num='f_27' data-table='1'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const SUBFORESTRY = 'subforestrie_list.php'
	//const HEADER = 'get_header.php'
	const ACT_LOCATION = 'get_act_location.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'subforestry',
		data: function () { 
			return {
				id: `${this.type}_subforestry_${this.line_count}`,
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: 0,
			type: '',
			lf_id: false,
			sf_id: false
		},
		methods: {
			change () {
				EventBus.$emit(`${this.type}_subforestry`, {index: this.line_count, value: this.selected})
			},
			fill (lf, sf) {
				if(this.$parent.data_location.subforestrie_list[lf])
				{
					this.options = this.$parent.data_location.subforestrie_list[lf];
					this.selected = sf ? sf : '0'
				} else {
					if(!this.$parent.data_location.subforestrie_list_queue[lf])
					{
						this.$parent.data_location.subforestrie_list_queue[lf] = true
						fetch(DB + SUBFORESTRY + '?id=' + lf)
						.then(data => data.json())
						.then(data => {
							this.$parent.data_location.subforestrie_list[lf] = data
							this.$parent.data_location.subforestrie_list_queue[lf] = false
							EventBus.$emit('subforestries_fetch_complete')

							if (data) {
								this.options = data;
								this.selected = sf ? sf : '0'
							}
							else {
								this.options = []
								this.selected = '0'
							}
						})
						.catch(err => console.log(err))
					} else {
						EventBus.$on('subforestries_fetch_complete', () => {
							this.options = this.$parent.data_location.subforestrie_list[lf];
							this.selected = sf ? sf : '0'
						})
					}
					
				}
				
			}
		},
		created: function () {
			EventBus.$on(`${this.type}_localforestry_${this.line_count}`, id => {
				this.fill(id)
			})

			let lf_id = this.$options.propsData.lf_id
			let sf_id = this.$options.propsData.sf_id
			if (lf_id)
				this.fill(lf_id, sf_id)
			else
				this.fill('0')
		},
		beforeDestroy () {
			EventBus.$off('subforestries_fetch_complete')
			EventBus.$off(`${this.type}_localforestry_${this.line_count}`)
		}
	}
</script>


// WEBPACK FOOTER //
// subforestry.vue?fcb796e8